import React, { useEffect, useState } from "react";

const QuantityEditModal = ({
  count,
  onClose,
  onConfirm,
  handleCount,
}: {
  count: number;
  onClose: () => void;
  onConfirm: () => void;
  handleCount: (type: "increase" | "decrease") => void;
}) => {
  const [isEditing, setIsEditing] = useState(false);
  useEffect(() => {
    setIsEditing(true);
  }, [count]);
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4"
      onClick={onClose} // 배경 클릭 시 닫기
    >
      <div
        className="bg-white p-6 rounded-lg max-w-md w-full"
        onClick={(e) => e.stopPropagation()} // 모달 클릭 시 이벤트 전파 방지
      >
        <h3 className="text-3xl font-bold mt-2 text-gray-800">개수 수정</h3>
        <div className="flex flex-col items-center justify-center mt-6 bg-white rounded-lg">
          <div className="flex items-center justify-center py-4">
            <button
              className="bg-gray-300 w-10 h-10 font-bold rounded-full text-2xl"
              onClick={() => handleCount("decrease")}
            >
              -
            </button>
            <span className="mx-4 text-4xl font-bold">{count}개</span>
            <button
              className="bg-blue-400 w-10 h-10 font-bold rounded-full text-2xl"
              onClick={() => handleCount("increase")}
            >
              +
            </button>
          </div>
          <div className="flex justify-between mt-8 w-full gap-x-2 font-bold">
            <button
              className="w-1/3 bg-gray-300 text-gray-800 px-4 py-2 rounded-2xl"
              onClick={onClose}
            >
              닫기
            </button>
            <button
              className={`w-2/3 bg-blue-500 text-white px-4 py-2 rounded-2xl inline-block ${
                !isEditing ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={onConfirm}
              disabled={!isEditing}
            >
              적용하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuantityEditModal;
